export default __webpack_public_path__ + "static/media/Wristwraps of the Reanimator.8ae6fb05.jpg";